<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
            <iq-card>
                <template v-slot:body>
                    <b-row>
                        <b-col xl="12" lg="12" sm="12">
                            <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                <b-form @submit.prevent="handleSubmit(storeUpdate)" @reset.prevent="reset" enctype="multipart/form-data">
                                    <b-row class="mt-2">
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="Division" vid="pre_division_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="pre_division_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.name_of_division')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="trainerProfile.pre_division_id"
                                                    :options="divisionPreList"
                                                    id="pre_division_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="District" vid="pre_district_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="pre_district_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.name_of_district')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="trainerProfile.pre_district_id"
                                                    :options="districtList"
                                                    id="pre_district_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="Upazilla" vid="pre_upazilla_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="pre_upazilla_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.city_corporation')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="trainerProfile.pre_corporation_id"
                                                    :options="cityCorporationList"
                                                    id="pre_upazilla_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="Union" vid="pre_union_id">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="pre_union_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.ward')}}
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="trainerProfile.pre_ward_id"
                                                    :options="wardList"
                                                    id="pre_union_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="Hospital" vid="hospital_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="hospital_id"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                {{$t('social_service.hospital_name')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-select
                                                    plain
                                                    v-model="trainerProfile.hospital_id"
                                                    :options="pauroshobaList"
                                                    id="pre_union_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col lg="6"  sm="12">
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-2" v-show="showData === 2">
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="Division" vid="pre_division_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="pre_division_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.name_of_division')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="trainerProfile.pre_division_id"
                                                    :options="divisionPreList"
                                                    id="pre_division_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="District" vid="pre_district_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="pre_district_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.name_of_district')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="trainerProfile.pre_district_id"
                                                    :options="districtList"
                                                    id="pre_district_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row v-show="showData === 2">
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="Upazilla" vid="pre_upazilla_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="pre_upazilla_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.name_of_upazilla')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="trainerProfile.pre_upazilla_id"
                                                    :options="upazilaList"
                                                    id="pre_upazilla_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="Union" vid="pre_union_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="pre_union_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.pourosoba')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="trainerProfile.pre_pauroshoba_id"
                                                    :options="pauroshobaList"
                                                    id="pre_union_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row v-show="showData === 2">
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="Hospital" vid="hospital_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="hospital_id"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                {{$t('social_service.hospital_name')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-select
                                                    plain
                                                    v-model="trainerProfile.hospital_id"
                                                    :options="pauroshobaList"
                                                    id="pre_union_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6"  sm="12">
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-2" v-show="showData === 3">
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="Division" vid="pre_division_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="pre_division_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.name_of_division')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="trainerProfile.pre_division_id"
                                                    :options="divisionPreList"
                                                    id="pre_division_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="District" vid="pre_district_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="pre_district_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.name_of_district')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="trainerProfile.pre_district_id"
                                                    :options="districtList"
                                                    id="pre_district_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row v-show="showData === 3">
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="Upazilla" vid="pre_upazilla_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="pre_upazilla_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.name_of_upazilla')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="trainerProfile.pre_upazilla_id"
                                                    :options="upazilaList"
                                                    id="pre_upazilla_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="Union" vid="pre_union_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="pre_union_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.name_of_union')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="trainerProfile.pre_union_id"
                                                    :options="unionList"
                                                    id="pre_union_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row v-show="showData === 3">
                                        <b-col lg="6"  sm="12">
                                            <ValidationProvider name="Hospital" vid="hospital_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="hospital_id"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                {{$t('social_service.hospital_name')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-select
                                                    plain
                                                    v-model="trainerProfile.hospital_id"
                                                    :options="pauroshobaList"
                                                    id="pre_union_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6"  sm="12">
                                        </b-col>
                                    </b-row>
                                    <b-list-group>
                                        <b-list-group-item class="d-flex align-items-center">
                                            <b-row>
                                            <b-col xl="4" lg="4" sm="12">
                                                <ValidationProvider name="Mobile" vid="mobile" rules="required">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="mobile"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                    {{$t('social_service.assgin_dept')}} <span class="text-danger">*</span>
                                                </template>
                                                <b-form-select
                                                    plain
                                                    v-model="mobile_list_input"
                                                    :options="divisionPreList"
                                                    id="pre_division_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col xl="4" lg="4" sm="12">
                                                <ValidationProvider name="Email" vid="email">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="email"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('social_service.ward_no')}}
                                                    </template>
                                                        <b-form-input
                                                        id="email"
                                                        v-model="email_list_input"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col xl="4" lg="4" sm="12">
                                                <ValidationProvider name="Message EN" vid="message_en">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="message_en"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                    {{$t('social_service.bed_no')}}
                                                </template>
                                                <b-form-input
                                                    id="mobile"
                                                    v-model="message_en_list_input"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                ></b-form-input>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                    <!-- <b-col xl="6" lg="6" sm="12">
                                                <ValidationProvider name="Message BN" vid="message_bn">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="message_bn"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                    {{$t('legal_institute_management.message_bn')}}
                                                </template>
                                                <b-form-textarea
                                                    id="message_bn"
                                                    v-model="message_bn_list_input"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    rows="2"
                                                    max-rows="6"
                                                    ></b-form-textarea>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                                </ValidationProvider>
                                            </b-col> -->
                                            <b-col xl="12" lg="12" sm="6">
                                                <div style="margin-top:15px;">
                                                    <b-button variant=" iq-bg-success" size="sm" @click.prevent="addItem()"><i class="ri-add-line mr-1"></i></b-button>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        </b-list-group-item>
                                    </b-list-group>
                                    <br>
                                        <b-row>
                                            <b-table-simple bordered>
                                                <thead thead-class="bg-primary">
                                                    <tr style="background-color: #609513;">
                                                        <th width="100px">
                                                            {{ $t('globalTrans.sl_no') }}
                                                        </th>
                                                        <th scope="col">
                                                            {{ $t('social_service.assgin_dept') }}
                                                        </th>
                                                        <th scope="col">
                                                            {{ $t('social_service.ward_no') }}
                                                        </th>
                                                        <th scope="col">
                                                            {{ $t('social_service.bed_no') }}
                                                        </th>
                                                        <th scope="col">
                                                            {{ $t('globalTrans.action') }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <b-tbody>
                                                    <b-tr>
                                                        <b-td v-if="sl > 0">
                                                            <span v-for="i in sl" :key="i">{{ i }}<br><br></span>
                                                        </b-td>
                                                        <b-td>
                                                            <ValidationProvider name="Mobile List" vid="mobile_list" rules="required">
                                                                <b-form-group slot-scope="{ valid, errors }">
                                                                    <b-form-input id="mobile_list" v-for="(item,index) in mobile_list" :key='index'
                                                                    v-model="item.value"
                                                                    :state="errors[0] ? false : (valid ? true : null)" class="mb-2">
                                                                    </b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-td>
                                                        <b-td>
                                                            <ValidationProvider name="Email List" vid="email_list" rules="required">
                                                                <b-form-group slot-scope="{ valid, errors }">
                                                                    <b-form-input id="email_list" v-for="(item,index) in email_list" :key='index'
                                                                    v-model="item.value"
                                                                    :state="errors[0] ? false : (valid ? true : null)" class="mb-2">
                                                                    </b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-td>
                                                        <b-td>
                                                            <ValidationProvider name="Message List (En)" vid="message_en_list" rules="required">
                                                                <b-form-group slot-scope="{ valid, errors }">
                                                                    <b-form-input id="message_en_list" v-for="(item,index) in message_en_list" :key='index'
                                                                    v-model="item.value"
                                                                    :state="errors[0] ? false : (valid ? true : null)" class="mb-2">
                                                                    </b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-td>
                                                        <b-td>
                                                            <ValidationProvider name="Message List (Bn)" vid="message_bn_list" rules="required">
                                                                <b-form-group slot-scope="{ valid, errors }">
                                                                    <b-form-input id="message_bn_list" v-for="(item,index) in message_bn_list" :key='index'
                                                                    v-model="item.value"
                                                                    :state="errors[0] ? false : (valid ? true : null)" class="mb-2">
                                                                    </b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-td>
                                                        <b-td>
                                                          <div v-if="sl > 0" class="text-center mb-2">
                                                            <b-button  variant="iq-bg-danger" size="lg" v-for="i in sl" :key="i" @click.prevent="removeItem(i-1)"><i class="ri-delete-bin-line m-0"></i></b-button>
                                                          </div>
                                                        </b-td>
                                                    </b-tr>
                                                </b-tbody>
                                            </b-table-simple>
                                        </b-row>
                                    <div class="row">
                                        <div class="col-sm-3"></div>
                                        <div class="col text-right">
                                            <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                            &nbsp;
                                            <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                        </div>
                                    </div>
                                </b-form>
                            </ValidationObserver>
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import { groBuyProStore, groBuyProUpdate } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        if (this.id) {
            const tmp = this.gete()
            this.e = tmp
            const notifications = tmp.notifications
            notifications.map((item, index) => {
                const email = notifications[index].email
                const NotificationList = this.$store.state.childService.NotificationList.filter(item => item.email === email)
                notifications[index].NotificationList = NotificationList
                return Object.assign(item, {})
            })
        }
    },
    mounted () {
        flatpickr('#date', {})
        core.index()
    },
    data () {
        return {
            totalPost: 0,
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            notifications: [
                {
                    mobile: '',
                    email: '',
                    message_en: '',
                    message_bn: '',
                    NotificationList: []
                }
            ],
            trainerProfile: {
        hospital_id: 0,
        blood_group_id: 0,
        religion_id: 0,
        pre_pauroshoba_id: 0,
        per_pauroshoba_id: 0,
        per_corporation_id: 0,
        pre_ward_id: 0,
        per_ward_id: 0,
        gender: 0,
        id: '',
        org_id: '',
        registration_year: 0,
        category: 0,
        registration_no: '',
        registration_date: '',
        name: '',
        name_bn: '',
        trade_name: '',
        trade_name_bn: '',
        father_name: '',
        father_name_bn: '',
        mother_name: '',
        mother_name_bn: '',
        nid: '',
        tin_no: '',
        bin_no: '',
        contact_no: '',
        sec_deposit_amount: '',
        pay_order_attachment: [],
        deposit_date: '',
        expire_date: '',
        photo: [],
        warehouse_details: '',
        warehouse_details_bn: '',
        sales_center_details: '',
        sales_center_details_bn: '',
        pre_division_id: 0,
        pre_region_id: 0,
        pre_district_id: 0,
        pre_upazilla_id: 0,
        pre_union_id: 0,
        pre_address: '',
        pre_address_bn: '',
        per_division_id: 0,
        per_region_id: 0,
        per_district_id: 0,
        per_upazilla_id: 0,
        per_union_id: 0,
        per_address: '',
        per_address_bn: '',
        area_id: 0,
        per_area_id: 0,
        pre_corporation_id: 0
      },
            showData: 0,
            checklist_id: 0,
            sl: 0,
            mobile_list: [],
            email_list: [],
            message_en_list: [],
            message_bn_list: [],
            mobile_list_input: '',
            email_list_input: '',
            message_en_list_input: '',
            message_bn_list_input: '',
            update: false,
            errorBn: '',
            errorEn: '',
            view: false,
               areaTypeList: [
                    { value: 1, text: this.$t('educational_management.city_corporation') },
                    { value: 2, text: this.$t('educational_management.pourosoba') },
                    { value: 3, text: this.$t('educational_management.name_of_union') }
                ]
        }
    },
    computed: {
    },
    watch: {
        'trainerProfile.area_id': function (newVal, oldVal) {
            this.officeList = this.getlocation(newVal)
        }
    },
    methods: {
        getlocation (areaID) {
            if (areaID === 1) {
                this.showData = 1
            }
            if (areaID === 2) {
                this.showData = 2
            }
            if (areaID === 3) {
                this.showData = 3
            }
            return true
        },
        gete () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        async storeUpdate () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            try {
                let result = null
                const loadinState = { loading: false, listReload: true }
                if (this.e.id) {
                    result = await RestApi.putData(childServiceBaseUrl, `${groBuyProUpdate}/${this.id}`, this.e)
                } else {
                    result = await RestApi.postData(childServiceBaseUrl, groBuyProStore, this.e)
                }
                this.$store.dispatch('mutateCommonProperties', loadinState)
                if (result.success) {
                    this.$toast.success({
                        title: 'Success',
                        message: this.id ? 'Data updated successfully' : 'Data save successfully',
                        color: '#D6E09B'
                    })
                    this.$bvModal.hide('modal-4')
                } else {
                    this.$refs.form.setErrors(result.errors)
                    this.$toast.error({
                        title: 'Error',
                        message: 'Operation failed! Please, try again.'
                    })
                }
            } catch (error) {
                this.$toast.error({
                title: 'Error',
                message: 'something went wrong! Please, try again.'
                })
                this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            }
        },
        addItem () {
          if (this.message_en_list_input !== '') {
            this.errorEn = ''
            this.errorBn = ''
            const existsMobileList = this.mobile_list.some(data => data.value === this.mobile_list_input)
            const existsEmailList = this.email_list.some(data => data.value === this.email_list_input)
            const existsMessagelistEn = this.message_en_list.some(data => data.value === this.message_en_list_input)
            if (existsMobileList === false && existsEmailList === false && existsMessagelistEn === false) {
              this.mobile_list.push({
                  value: this.mobile_list_input
              })
              this.email_list.push({
                  value: this.email_list_input
              })
              this.message_en_list.push({
                  value: this.message_en_list_input
              })
              this.sl = this.sl + 1
            } else {
              if (existsMessagelistEn === false) {
                this.errorBn = 'Message (Bn) already exists...!'
              } else if (existsMessagelistEn === true) {
                this.errorEn = 'Message (En) already exists...!'
              } else {
                this.errorBn = 'Message (Bn) already exists...!'
                this.errorEn = 'Message(En) already exists...!'
              }
            }
            this.mobile_list_input = ''
            this.email_list_input = ''
            this.message_en_list_input = ''
          }
        },
        removeItem (i) {
            this.mobile_list.splice(i, 1)
            this.email_list.splice(i, 1)
            this.message_en_list.splice(i, 1)
            this.message_bn_list.splice(i, 1)
            this.sl = this.sl - 1
        }
    }
}

</script>
